import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttendeeProgram, CueProgram, Program, Session } from 'globals/store/programs.data';
import { Dictionary } from '@ngrx/entity';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Attendee } from 'globals/store/attendees.data';
import { removeUniqueStringFromList } from '../../helpers/helpers';
import { BrandingData } from 'globals/store/publish.data';
import publicHelpers from 'globals/helpers/public-helpers';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { ShareWrapper } from '../share/share-wrapper.component';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { CommonModule } from '@angular/common';
import { TagsComponent } from '../manage/tags.component';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';
import { EntityIdsToTagDataPipe } from 'src/app/services/pipes/idsToTagData.pipe';
import { SharedTimelineComponent } from 'src/app/components/wrappers/shared-timeline-wrapper.component';

@Component({
    selector: 'attendees-view',
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0', overflow: 'hidden', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    templateUrl: './attendees-view.html',
    styleUrls: ['./../program/program.logistics.scss'],
    styles: [`
    .session { margin-bottom: 25px; }
    .times { margin-bottom: 15px; display: flex; align-items: center; }
    .header-right { margin: 15px 0 10px auto; cursor: pointer; width: fit-content; }
    h5 { line-height: unset !important; }
  `],
    standalone: true,
    imports: [BrandingWrapperComponent, SharedTimelineComponent, EntityIdsToTagDataPipe, CommonModule, ProgramDayDate, TagsComponent, ExpandingWrapperComponent]
})
export class AttendeesViewComponent<P extends AttendeeProgram & (Program | CueProgram)> {

  @Input() eventTitle: string
  @Input() programs: P[]
  @Input() attendees: Dictionary<Attendee>
  @Input() readOnly: boolean
  @Input() loading: boolean
  @Input() unavailable: boolean
  @Input() brandingData: BrandingData
  unavailableMessage: string =  "The attendees view is not currently available."

  @Output() openTagger: EventEmitter<any> = new EventEmitter()
  @Output() save: EventEmitter<{ session: Session, programId: string }> = new EventEmitter()

  helpers = publicHelpers
  expandedStates: Dictionary<boolean> = {}

  removeTag(session: Session, programId: string, id: string) {
    removeUniqueStringFromList(session.attendeeTags, id)
    this.save.emit({ session, programId })
  }
  
  trackByIndex(index) {
    return index
  }

  trackById<T extends { id?: string }>(_, item: T) {
    return item.id
  }

  trackBySelf<T>(_, item: T) {
    return item // in case of primitive, compares primitives.  Objects compare references
  }

  expandProgram(program: P) {
    this.expandedStates[program.id + ':room'] = true
  }

  collapseProgram(program: P) {
    this.expandedStates[program.id + ':room'] = false
  }

  expandAll() {
    console.log("Expand all")
    this.programs.forEach(p => this.expandedStates[p.id] = true)
  }

  collapseAll() {
    console.log("Collapse all")
    this.programs.forEach(p => this.expandedStates[p.id] = false)
  }

  

}

